import {ListViewProvider, useListView} from './core/ListViewProvider'
import {QueryRequestProvider} from './core/QueryRequestProvider'
import {QueryResponseProvider} from './core/QueryResponseProvider'
// import {KTCard} from '../../../../_metronic/helpers'
import { StatesListHeader } from './components/header/StatesListHeader'
import { StatesTable } from './table/StatesTable'
import { StateEditModal } from './state-edit-modal/StateEditModal'
import { KTCard } from '../../../../../_metronic/helpers'
import { useQueryResponse } from './core/QueryResponseProvider'
import { State } from './core/_models'
// import { SufalamsTable } from './table/SufalamsTable'
// import { SufalamEditModal } from './sufalam-edit-modal/SufalamEditModal'

const StatesList = () => {
  const {itemIdForUpdate} = useListView()
  const {isLoading, response} = useQueryResponse()
  const state = response?.data?.find((state: State) => state.id === itemIdForUpdate) || {id: itemIdForUpdate, name: ''}

  return (
    <>
      <KTCard>
        <StatesListHeader />
        <StatesTable />
      </KTCard>
      {itemIdForUpdate !== undefined && <StateEditModal state={state} isStateLoading={isLoading} />}
    </>
  )
}

const StatesListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListViewProvider>
        <StatesList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export {StatesListWrapper}
